export const PHONE_NUMBER = "952490400";
export const PHONE_DISPLAY = "952 490 400";
export const PHONE_HREF = `tel:${PHONE_NUMBER}`;

export const WHATSAPP_NUMBER = "34670743011";
export const WHATSAPP_TEXT = "Hola%2C%20me%20gustaría%20solicitar%20información";
export const WHATSAPP_HREF = `https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_TEXT}`;
